module.exports = __webpack_public_path__ + "dist/introduce_6.bde73ab6.png";